import axios from "axios";

const url = process.env.REACT_APP_API_URL;
console.log(url);

export async function GetInfoMC(token, ROUTE_URL, number, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}${ROUTE_URL}?kks_psats_info&${number}&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function PostControlMC(token, number, data) {
  let response = await axios({
    method: "POST",
    url: `${url}/set_control_mc/${number}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  });
  return response;
}

export async function GetTrackNMEA(token, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_knap?track_NMEA&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetKKCinfo(token, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_vpy?kks_status&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetConnMC(token, offset, limit) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_mc?kks_psats_info&offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetApkKonsul(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/info_state`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetTrackNMEAcount(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_track_nmea_count`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetConnPYV(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_pyv`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function POSTConnPYV(token, data) {
  let response = await axios({
    method: "POST",
    url: `${url}/set_control_pyv`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  });
  return response;
}

export async function GetConnERA(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_era`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function PostConnERA(token, data) {
  let response = await axios({
    method: "POST",
    url: `${url}/set_control_era`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  });
  return response;
}

export async function GetConnPULSN(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_conf_lsn`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetConnKONSUL(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_konsul`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function PostConnKONSUL(token, data) {
  let response = await axios({
    method: "POST",
    url: `${url}/set_control_konsul`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  });
  return response;
}

export async function GetConnVIS(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_conn_vis`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function PostConnVIS(token, data) {
  let response = await axios({
    method: "POST",
    url: `${url}/set_control_vis`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  });
  return response;
}

export async function GetControlVIS(token, limit, offset) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_control_vis?limit=${offset}&offset=${limit}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}

export async function GetConnKNAP(token) {
  let response = await axios({
    method: "GET",
    url: `${url}/get_control_knap`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
}
